import { render, staticRenderFns } from "./EtapaDadosPessoais.vue?vue&type=template&id=61108e4c"
import script from "./EtapaDadosPessoais.vue?vue&type=script&lang=js"
export * from "./EtapaDadosPessoais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports